import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select/async";
import { normalize } from "common/lib/normalize";
import {
  GroupBase,
  OptionsOrGroups,
} from "react-select/dist/declarations/src/types";
import { getContractors } from "common/services/contractors.service";

const SelectSubContractor = ({ validation }: { validation: any }) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched.subContractedTo && validation.errors.subContractedTo
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched.subContractedTo &&
          validation.errors.subContractedTo
            ? "red"
            : "#ced4da",
      },
    }),
  };

  const [data, setData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let filters = {};

        const response = await getContractors({
          pagination: {
            page: 1,
            pageSize: 20,
          },
          filters,
        });
        setData(normalize(response.data));
      } catch (e) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(() => {
    const mainOptions = data.map((el: any) => {
      return {
        value: el?.id,
        label: `${el?.contractorName} ( ${el?.acronym} )`,
      };
    });
    mainOptions.unshift({ value: null, label: "None" });

    return mainOptions;
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="subContractedTo-field" className="form-label">
        Sub Contracted To
      </Label>
      <Select
        name="subContractedTo"
        id="subContractedTo"
        value={
          validation.values.subContractedTo.value
            ? validation.values.subContractedTo
            : null
        }
        placeholder="Select sub contracted to"
        onChange={(value: any) => {
          validation.setFieldValue("subContractedTo", value);
          validation.setFieldError("subContractedTo", "");
        }}
        defaultOptions={options}
        // @ts-ignore
        loadOptions={(
          inputValue: string,
          callback: (options: OptionsOrGroups<any, GroupBase<any>>) => void
        ) => {
          return getContractors({
            pagination: {
              page: 1,
              perPage: 20,
            },
            filters: {
              $or: [
                {
                  contractorName: {
                    $containsi: inputValue,
                  },
                },
                {
                  acronym: {
                    $containsi: inputValue,
                  },
                },
              ],
            },
          }).then((result: any) => {
            const parsedData = normalize(result.data);
            callback(
              parsedData.map((el: any) => {
                return {
                  value: el?.id,
                  label: `${el?.contractorName} ( ${el?.acronym} )`,
                };
              })
            );
          });
        }}
        onBlur={() => validation.setFieldTouched("subContractedTo", true)}
        className={
          validation.touched.subContractedTo &&
          validation.errors.subContractedTo
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>{validation.errors.subContractedTo?.value}</FormFeedback>
    </FormGroup>
  );
};

export default SelectSubContractor;
